<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DKeywordPreview',
  extends: compoment
}
</script>
